<template>
<div id="reporte_seguros_carta" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Reportes Seguros Carta Porte" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        <v-card-title>
                            <span class="headline" ></span>
                        </v-card-title>
                        <v-form ref="form" lazy-validation>
                            <v-container grid-list-md text-xs-center>
                                <v-layout row wrap>
                                    <v-flex s12 m6 l6>
                                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false"  transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }" >
                                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu1 = false" >
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex s12 m6 l6>
                                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }" >
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu2 = false" >
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn color="success" @click="generar_reporte_sqs" >
                            <v-icon>done</v-icon>Generar Reporte
                        </v-btn>
                    </v-card-actions>

                    <v-card-text>
                        <v-refresh-button :funcion="cargar" />
                        <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontró ningun registro</v-alert>
                            </template>

                            <template slot="actions" slot-scope="props" >
                                <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                                <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                    <v-icon dark>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-client-table>
                    </v-card-text>

                 </base-material-card>


            </v-flex>
        </v-layout>
    </v-container>

    <v-divider></v-divider>

</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    data: () => ({
        permisoEliminar: false,
        fab: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Reporte Seguros Carta Porte",
                disabled: true,
                to: ""
            }
        ],
        datos: [],
        columns: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },

        model: {
            rfc: "",
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            reporte_url: "/reportes/seguros_carta/",
            nombre_reporte: "Seguros Carta Porte",
            tipo: "SegurosCartaPorte",
        },

        menu1: false,
        menu2: false,

        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },

    }),

    methods: {
        validaFecha: function(fecha){
             if (fecha == "Invalid date")
                return "Fecha no válida.";
            else
              return true;
        },
        validaAnio: function(){
            if (this.model.fecha_de != "" && this.model.fecha_a != ""){
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            }
            return true;
        },
        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "SegurosCartaPorte"
            };
            this.datos_arbol = [];
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },


        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },

        generar_reporte_sqs() {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = this.model;
                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        data: data
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406){
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                    }).then(() => {
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                    });
            }
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },

        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
              }
          });
        },

    }, //methods
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
            this.permisoEliminar = true;
        this.cargar();
    }
};
</script>

<style>
#VueTables_th--actions {
        width: 155px;
    }
</style>
